// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8500) return "static/chunks/8500-af6eb8da1db67d05.js";
	if (chunkId === 8568) return "static/chunks/b1644e8c-7b5c1fda88c184e9.js";
	if (chunkId === 2926) return "static/chunks/2926-4e9467e2dd50eeff.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"894":"dfa41246588d376e","2030":"4895eff8091649bf","3155":"23d6fed41cfa2b34","3514":"bc225eda9d72ef18","3778":"692586a52008c2c1","3995":"26fc9dc2bebb0426","4879":"4f7bc67df6a1c036","5786":"22cc2d51c947daff","6381":"d912f76c135ae749","7066":"a20d0d72e4d5973b","7069":"cf6a1ffc317b2f6b","9592":"c904b1fa6f48904a"}[chunkId] + ".js";
};